import React, { useState, useEffect } from "react";
import ClickOutside from 'react-click-outside';
import ApiCaller from "api/apiCaller";
import NotiItem from './NotiItem';
import "./index.css";
import t from "utils/Lang";

export default function PopupMenu({ tooglePopupMenu }) {
    const [notifications, setNotifications] = useState([]);
    const [totalNotifications, setTotalNotifications] = useState([]);
    const [page, setPage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const limit = 10;
    const onClickOutsideHandler = () => {
        if (tooglePopupMenu) {
            tooglePopupMenu();
        }
    }
    const getNotifications = async () => {
        setIsLoading(true); 
        const res = await ApiCaller.get(`notification/list?page=${page}&limit=${limit}`);
        if (res?.result) {
            setNotifications([
                ...notifications,
                ...(res?.result ?? []),
            ]);
            setTotalNotifications(res?.count);
            setIsLoading(false);
        } else {
            console.log(res);
            setIsLoading(false);
        }
    };
    const loadMore = () => {
        setPage(page + 1);
    }
    useEffect(() => {
        getNotifications();
    }, []);
    useEffect(() => {
        getNotifications();
    }, [page]);
    return (
        <ClickOutside onClickOutside={onClickOutsideHandler}>
            <div className="popup-menu__main">
                <div className="popup-menu__menu">
                    <div className="popup-menu__header">
                        <span>{t().nav__notification}</span>
                    </div>
                    <div className="popup-menu__notification-container">
                        {notifications.map((notification, index) =>
                            <NotiItem
                                notification={notification}
                                key={index}
                            />
                        )}
                        {notifications && notifications.length === 0 && !isLoading &&
                            <div className="popup-menu__notification-loading">Chưa có thông báo nào</div>
                        }
                        {isLoading &&
                            <div className="popup-menu__notification-loading">Đang tải...</div>
                        }
                        {notifications.length < totalNotifications &&
                            <button
                                disabled={isLoading}
                                onClick={loadMore}
                                className={`popup-menu__notification-load-more ${isLoading ? 'isLoading' : ''}`}
                            >
                                Tải thêm
                            </button>
                        }
                    </div>
                </div>
            </div>
        </ClickOutside>
    );
}
